import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visibleWhen"],
  _excluded2 = ["visibleWhen", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import isEmpty from "lodash/isEmpty";
import React, { useState } from "react";
import { CollectedCSAT } from "./CollectedCSAT";
import { OTHER_REASON } from "./csatReasons";
import { OpenReasonTextArea } from "./OpenReasonTextArea";
import { SubmitButton } from "./SubmitButton";
import { TellUsMore } from "./TellUsMore";
import { trackCsatSubmit } from "./utils";
import { YesNoButtons } from "./YesNoButtons";
export var ComprehensiveCSATCollection = function ComprehensiveCSATCollection(_ref) {
  var visibleWhen = _ref.visibleWhen,
    context = _objectWithoutProperties(_ref, _excluded);
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    completed = _useState2[0],
    setCompleted = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    feedback = _useState4[0],
    setFeedback = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    checkedReasons = _useState6[0],
    setCheckedReasons = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    openReason = _useState8[0],
    setOpenReason = _useState8[1];
  if (visibleWhen === false) {
    return null;
  }
  if (completed) {
    return /*#__PURE__*/React.createElement(CollectedCSAT, null);
  }
  var handleYesNoResponse = function handleYesNoResponse(value) {
    setFeedback(value);
    if (value === "Yes") {
      setCompleted(true);
      trackCsatSubmit("Yes", [], "", context);
    }
  };
  var handleFormSubmission = function handleFormSubmission(event) {
    event.preventDefault();
    setCompleted(true);
    trackCsatSubmit("No", checkedReasons, openReason, context);
  };
  var brandOrRetailerToken = context.brandOrRetailerToken,
    issue = context.issue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(YesNoButtons, {
    visibleWhen: feedback === undefined,
    value: feedback,
    onChange: handleYesNoResponse,
    brandOrRetailerToken: brandOrRetailerToken,
    issue: issue
  }), /*#__PURE__*/React.createElement(CSATForm, {
    onSubmit: handleFormSubmission,
    visibleWhen: feedback === "No"
  }, /*#__PURE__*/React.createElement(TellUsMore, {
    checkedReasons: checkedReasons,
    setCheckedReasons: setCheckedReasons
  }), /*#__PURE__*/React.createElement(OpenReasonTextArea, {
    visibleWhen: checkedReasons.includes(OTHER_REASON(strictLocalize).id),
    value: openReason,
    onChange: setOpenReason
  }), /*#__PURE__*/React.createElement(SubmitButton, {
    disabled: isEmpty(checkedReasons) && isEmpty(openReason.trim())
  })));
};
var CSATForm = function CSATForm(_ref2) {
  var visibleWhen = _ref2.visibleWhen,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  if (!visibleWhen) {
    return null;
  }
  return /*#__PURE__*/React.createElement("form", _objectSpread({}, props), children);
};